import Vue from 'vue'

/**
 * 每个题目的快照撤销栈
 * key = questionId，value = 该题的选项 + 标题历史快照数组
 * 在每次保存（saveOptionsToServer / saveTitleToServer）之前压栈
 */

const MAX_DEPTH = 20

const state = {
  stacks: {}, // { [questionId]: [snapshot, ...] }
  maxDepth: MAX_DEPTH,
}

const getters = {
  canUndo: (state) => (qid) => {
    const s = state.stacks[qid]
    return !!(s && s.length > 0)
  },
}

const mutations = {
  pushHistory(state, { qid, snapshot }) {
    if (qid == null) return
    const key = String(qid)
    if (!state.stacks[key]) {
      Vue.set(state.stacks, key, [])
    }
    const s = state.stacks[key]
    s.push(JSON.parse(JSON.stringify(snapshot)))
    if (s.length > state.maxDepth) s.shift()
  },
  popHistory(state, qid) {
    if (qid == null) return null
    const s = state.stacks[String(qid)]
    if (!s || !s.length) return null
    const snapshot = s.pop()
    return JSON.parse(JSON.stringify(snapshot))
  },
  clearHistory(state, qid) {
    if (qid == null) return
    Vue.delete(state.stacks, String(qid))
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}